import React, { useMemo } from 'react';
import { toast } from 'react-toastify';
import { XuiServerConfig } from '../../../core/models/xui';
import { Button } from '../../../core/components/Button';
import './XuiExportDialog.css';

interface Props {
    servers: XuiServerConfig[];
    onClose: () => void;
}

export const XuiServersExportDialog: React.FC<Props> = ({ servers, onClose }) => {
    const csv = useMemo(() => {
        return servers
            .map(s => [s.identity, s.frendlyname, s.type ?? '', s.inboundId, s.host, s.user, s.password ?? '', s.token ?? ''].join(','))
            .join('\n');
    }, [servers]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(csv);
            toast.success('CSV скопирован в буфер обмена');
        } catch {
            toast.error('Не удалось скопировать в буфер');
        }
    };

    return (
        <div className="xed-overlay" onMouseDown={onClose} role="presentation">
            <div className="xed-dialog" onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
                <div className="xed-header">
                    <h3>Экспорт XUI серверов (CSV)</h3>
                    <button className="xed-close" onClick={onClose} aria-label="Закрыть">✕</button>
                </div>

                <div className="xed-controls">
                    <div className="xed-actions">
                        <Button variant="secondary" onClick={handleCopy} disabled={servers.length === 0}>
                            Скопировать
                        </Button>
                    </div>
                </div>

                <textarea
                    className="xed-json"
                    readOnly
                    value={csv}
                    placeholder="Нет данных серверов…"
                />
            </div>
        </div>
    );
};
